<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">UNPAID HYGIENE PERMIT INVOICES</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a></li>
                    <li class="breadcrumb-item active">Pending Payment</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Pending Invoices</p>
                      <h4 class="mb-0">{{ numberFormat(totalBusiness) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-receipt font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Outstanding</p>
                      <h4 class="mb-0">KES {{ numberFormat(totalAmount) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-danger">
                        <span class="avatar-title">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Displayed Records</p>
                      <h4 class="mb-0">{{ paginatedInvoices.length }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                        <span class="avatar-title">
                          <i class="bx bx-list-ul font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Status</p>
                      <h4 class="mb-0 text-warning">Awaiting Payment</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-time-five font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- tool bar -->
          <ToolBarHygiene/>
          <!-- end of toolbar -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100"
                       role="toolbar">
                    <h4 class="card-title mb-0 text-uppercase">
                      <i class="bx bx-time-five me-2"></i>UNPAID HYGIENE PERMIT INVOICES
                    </h4>
                    <div>
                      <button @click="showExportModal = true" class="btn btn-success btn-sm me-2">
                        <i class="bx bx-download me-1"></i> Export CSV
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-light pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-between p-3 w-100">
                    <div class="flex-grow-1 me-3">
                      <form class="app-search p-0 m-0">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search by Business Name, ID, Bill Number, or Officer Name..."
                                 spellcheck="false" data-ms-editor="true">
                          <span class="bx bx-search-alt"></span>
                        </div>
                      </form>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="me-2">
                        <input
                            type="date"
                            v-model="filterDateRange.startDate"
                            class="form-control form-control-sm"
                            placeholder="Start Date"
                            @change="applyDateFilter"
                            title="Filter by start date"
                        />
                      </div>
                      <div class="me-2">
                        <input
                            type="date"
                            v-model="filterDateRange.endDate"
                            class="form-control form-control-sm"
                            placeholder="End Date"
                            @change="applyDateFilter"
                            title="Filter by end date"
                        />
                      </div>
                      <div class="me-2" v-if="filterDateRange.startDate || filterDateRange.endDate">
                        <button
                            @click="clearDateFilter"
                            class="btn btn-sm btn-outline-danger"
                            title="Clear date filter"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                      <div class="me-2">
                        <select v-model="selectedFilter" class="form-select form-select-sm">
                          <option value="">All Categories</option>
                          <option value="Canteens">Canteens</option>
                          <option value="Bars">Bars/Pubs</option>
                          <option value="Category B Hotels">Hotels</option>
                          <option value="Eating House">Eating House</option>
                          <option value="Food Wholesale">Food Wholesale</option>
                        </select>
                      </div>
                      <div>
                        <select v-model="pageSize" class="form-select form-select-sm">
                          <option value="10">10 per page</option>
                          <option value="25">25 per page</option>
                          <option value="50">50 per page</option>
                          <option value="100">100 per page</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Active Filter Indicator -->
                <div v-if="filterDateRange.startDate || filterDateRange.endDate" class="card-body py-2 bg-light border-bottom">
                  <div class="d-flex align-items-center">
                    <i class="bx bx-filter-alt text-primary me-2"></i>
                    <small class="text-muted">
                      <strong>Date Filter Active:</strong>
                      {{ filterDateRange.startDate || 'Any' }} to {{ filterDateRange.endDate || 'Any' }}
                    </small>
                    <button @click="clearDateFilter" class="btn btn-link btn-sm ms-auto text-danger">
                      Clear Filter
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading pending invoices...</p>
                  </div>

                  <!-- Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover table-nowrap mb-0">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="selectAll" @change="toggleSelectAll">
                          </div>
                        </th>
                        <th scope="col">Invoice No.</th>
                        <th scope="col">Business ID</th>
                        <th scope="col">Business Name</th>
                        <th scope="col">Date Invoiced</th>
                        <th scope="col">Category</th>
                        <th scope="col">Invoiced By</th>
                        <th scope="col" class="text-end">Amount</th>
                        <th scope="col" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in paginatedInvoices" :key="index"
                          :class="{'table-active': selectedItems.includes(item.billNo)}"
                          class="hover-row">
                        <td>
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" :value="item.billNo" v-model="selectedItems">
                          </div>
                        </td>
                        <td class="text-nowrap">
                          <span class="badge bg-warning text-dark">{{ item.billNo }}</span>
                        </td>
                        <td class="text-nowrap">{{ item.businessID }}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                              <div class="avatar-xs">
                                <span class="avatar-title rounded-circle bg-soft-primary text-primary">
                                  {{ item.businessName ? item.businessName.charAt(0).toUpperCase() : 'B' }}
                                </span>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0 text-capitalize">{{ item.businessName }}</h6>
                            </div>
                          </div>
                        </td>
                        <td class="text-nowrap">
                          <div>{{ formatDate(item.dateCreated) }}</div>
                          <small class="text-muted">{{ formattedTime(item.dateCreated) }} ({{ formatTimeAgo(item.dateCreated) }})</small>
                        </td>
                        <td>
                          <span class="badge bg-info-subtle">Industry</span>
                        </td>
                        <td>
                          <div>{{ item.names }}</div>
                        </td>
                        <td class="text-end">
                          <span class="fw-bold text-danger">KES {{ numberFormat(item.billTotal) }}</span>
                        </td>
                        <td>
                          <div class="d-flex gap-1 justify-content-center">
                            <button @click="getBusiness(item.billNo, item.businessID)" type="button"
                                    class="btn btn-soft-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target=".receipting-modal"
                                    title="View Details">
                              <i class="bx bx-show"></i>
                            </button>

                            <button @click="printBill(item.billNo)"
                                    class="btn btn-soft-success btn-sm"
                                    title="Print Invoice">
                              <i class="bx bx-printer"></i>
                            </button>

                            <button @click="getBusiness(item.billNo, item.businessID)" type="button"
                                    class="btn btn-soft-info btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target=".SMS-modal"
                                    title="Resend SMS">
                              <i class="bx bx-chat"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Empty State -->
                    <div v-if="paginatedInvoices.length === 0" class="text-center py-5">
                      <i class="bx bx-file font-size-64 text-muted"></i>
                      <h5 class="mt-3">No Pending Invoices Found</h5>
                      <p class="text-muted">There are no unpaid invoices matching your search criteria.</p>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div v-if="serverPagination.totalRecords > 0" class="row mt-4">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{ startRecord }} to {{ endRecord }} of {{ serverPagination.totalRecords }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate float-end">
                        <ul class="pagination">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="javascript:void(0)" @click="previousPage">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li class="page-item" v-for="page in visiblePages" :key="page"
                              :class="{ active: page === currentPage }">
                            <a class="page-link" href="javascript:void(0)" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="javascript:void(0)" @click="nextPage">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Footer with Actions -->
                <div class="card-footer bg-light" v-if="selectedItems.length > 0">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{{ selectedItems.length }}</strong> invoice(s) selected
                    </div>
                    <div>
                      <button class="btn btn-sm btn-info me-2" @click="sendBulkSMS">
                        <i class="bx bx-message-dots me-1"></i> Send Bulk SMS
                      </button>
                      <button class="btn btn-sm btn-danger" @click="clearSelection">
                        <i class="bx bx-x me-1"></i> Clear Selection
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <!-- Modals -->
  <BusinessDetailsModal
      :businessDetails="business"
      :billDetails="billDetail"
      @show-payment-modal="showPaymentMethod"
      @print-invoice="printBill"
      @print-receipt="printReceipt"
  />

  <InvoiceSMSModal
      :business="business"
      :billDetail="billDetail"
      @resend-message="resendMessage"
  />

  <PaymentModal
      :billDetails="billDetail"
      :paymentData="paymentData"
      :paymentMethod="paymentMethod"
      :transactionSummary="transactionSummary"
      :transactionCompleted="transactionCompleted"
      :receiptDetails="receiptDetails"
      :message="message"
      :phoneNumber="phoneNumber"
      @update-phone-number="updatePhoneNumber"
      @show-transaction-summary="showTransactionSummary"
      @make-payment="makePayment"
      @print-receipt="printReceiptFromPayment"
  />

  <!-- Export Modal -->
  <div class="modal fade" id="exportModal" tabindex="-1" v-show="showExportModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bx bx-download me-2"></i>Export Pending Invoices
          </h5>
          <button type="button" class="btn-close" @click="closeExportModal" aria-label="Close" :disabled="isExporting"></button>
        </div>
        <div class="modal-body">
          <!-- Export Summary -->
          <div class="alert alert-info mb-3">
            <h6 class="alert-heading mb-2"><i class="bx bx-info-circle me-1"></i> Export Summary</h6>
            <ul class="list-unstyled mb-0 small">
              <li><strong>Total Records:</strong> {{ serverPagination.totalRecords || 0 }}</li>
              <li><strong>Current Page:</strong> {{ pendingInvoicing.length }} records</li>
              <li v-if="selectedItems.length > 0" class="text-warning">
                <strong>Selected Items:</strong> {{ selectedItems.length }} records will be exported
              </li>
              <li v-else class="text-success">
                <strong>Export All:</strong> All {{ serverPagination.totalRecords || 0 }} records will be exported
              </li>
              <li v-if="filterDateRange.startDate || filterDateRange.endDate">
                <strong>Date Range:</strong>
                {{ filterDateRange.startDate || 'Start' }} to {{ filterDateRange.endDate || 'End' }}
              </li>
              <li v-if="search">
                <strong>Search Filter:</strong> "{{ search }}"
              </li>
            </ul>
          </div>

          <!-- Export Options -->
          <div class="export-options mb-3" v-if="!isExporting">
            <h6 class="mb-2">
              <i class="bx bx-list-check me-1"></i>Select Fields to Export:
            </h6>
            <div class="d-flex gap-2 mb-2">
              <button type="button" class="btn btn-sm btn-outline-primary" @click="selectAllFields">
                <i class="bx bx-check-double"></i> Select All
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="deselectAllFields">
                <i class="bx bx-x"></i> Deselect All
              </button>
            </div>
            <div class="row g-2">
              <div class="col-6" v-for="(field, index) in exportFields" :key="index">
                <div class="form-check border rounded p-2"
                     :class="{'bg-light': field.selected, 'border-primary': field.selected}"
                     style="cursor: pointer;"
                     @click="field.selected = !field.selected">
                  <input class="form-check-input"
                         type="checkbox"
                         v-model="field.selected"
                         :id="'field-' + index"
                         @click.stop>
                  <label class="form-check-label w-100"
                         :for="'field-' + index"
                         style="cursor: pointer;">
                    {{ field.label }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Export Progress -->
          <div v-if="isExporting" class="export-progress">
            <div class="text-center mb-3">
              <div class="spinner-border text-primary mb-2" role="status">
                <span class="visually-hidden">Exporting...</span>
              </div>
              <p class="mb-1"><strong>Exporting Data...</strong></p>
              <p class="text-muted small mb-0">
                <span v-if="exportProgress < 90">Fetching records from server...</span>
                <span v-else-if="exportProgress < 100">Generating CSV file...</span>
                <span v-else>Completing export...</span>
              </p>
            </div>
            <div class="progress" style="height: 25px;">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                   role="progressbar"
                   :style="{width: exportProgress + '%'}"
                   :aria-valuenow="exportProgress"
                   aria-valuemin="0"
                   aria-valuemax="100">
                <strong>{{ exportProgress }}%</strong>
              </div>
            </div>
            <p class="text-center text-muted small mt-2 mb-0">
              Please wait while we fetch all records...
            </p>
          </div>

          <!-- Warning Message -->
          <div v-if="!isExporting && serverPagination.totalRecords > 1000" class="alert alert-warning mt-3 mb-0">
            <i class="bx bx-error-circle me-1"></i>
            <small>
              <strong>Large Export:</strong> This will export {{ serverPagination.totalRecords }} records.
              This may take a few moments.
            </small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-secondary"
                  @click="closeExportModal"
                  :disabled="isExporting">
            <i class="bx bx-x me-1"></i>Cancel
          </button>
          <button type="button"
                  class="btn btn-success"
                  @click="exportToCSV"
                  :disabled="isExporting || !hasSelectedFields">
            <i class="bx bx-download me-1"></i>
            <span v-if="isExporting">Exporting...</span>
            <span v-else>
              Export {{ selectedItems.length > 0 ? selectedItems.length : serverPagination.totalRecords || 0 }} Records
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarHygiene from "@/components/hygiene/ToolBarHygiene.vue";
import BusinessDetailsModal from "@/components/hygiene/modals/BusinessDetailsModal.vue";
import InvoiceSMSModal from "@/components/hygiene/modals/InvoiceSMSModal.vue";
import PaymentModal from "@/components/hygiene/modals/PaymentModal.vue";
import {execute, fire, biller, trade, health, getRight, authUrl, parking, rent} from "@/api";

export default {
  name: "CertHygienePending",
  components: {
    NavigationBar,
    ToolBarHygiene,
    BusinessDetailsModal,
    InvoiceSMSModal,
    PaymentModal
  },
  data() {
    return {
      loading: true,
      search: '',
      message: '',
      pendingInvoicing: [],
      totalBusiness: 0,
      totalAmount: 0,

      // Pagination
      currentPage: 1,
      pageSize: 25,
      serverPagination: {
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        hasNextPage: false,
        hasPreviousPage: false
      },

      // Selection
      selectAll: false,
      selectedItems: [],

      // Filtering
      selectedFilter: '',
      filterDateRange: {
        startDate: '',
        endDate: ''
      },

      // Export
      showExportModal: false,
      isExporting: false,
      exportProgress: 0,
      exportFields: [
        {key: 'billNo', label: 'Invoice No.', selected: true},
        {key: 'businessID', label: 'Business ID', selected: true},
        {key: 'businessName', label: 'Business Name', selected: true},
        {key: 'dateCreated', label: 'Date Invoiced', selected: true},
        {key: 'names', label: 'Invoiced By', selected: true},
        {key: 'billTotal', label: 'Amount', selected: true}
      ],

      // Business and Bill Details
      business: {
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        physicalAddress: null,
        buildingName: null,
        plotNumber: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: 0.0,
        lng: 0.0
      },
      billDetail: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        billTotal: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category: null
      },

      // Payment Modal States
      paymentMethod: false,
      paymentPanel: false,
      transactionSummary: false,
      transactionCompleted: false,
      phoneNumber: '',
      paymentData: {
        amount: 0,
        accNo: '',
        phoneNumber: '',
        bankReceiptNo: '',
        eCitizenReceiptNo: '',
        paymentMode: '',
        sessionNames: '',
        sessionIdNo: '',
        sessionPhoneNumber: ''
      },
      receiptDetails: {},
      timer: null,
      searchTimeout: null
    }
  },

  computed: {
    // Since we're using server-side pagination, we don't need client-side filtering
    // The server handles all filtering, so we just return the data as-is
    filteredInvoices() {
      return this.pendingInvoicing;
    },

    paginatedInvoices() {
      // Server already returns paginated data, so return as-is
      return this.pendingInvoicing;
    },

    totalPages() {
      // Use server pagination info
      return this.serverPagination.totalPages || 0;
    },

    startRecord() {
      if (this.pendingInvoicing.length === 0) return 0;
      return ((this.currentPage - 1) * this.pageSize) + 1;
    },

    endRecord() {
      const end = this.currentPage * this.pageSize;
      return end > this.serverPagination.totalRecords ? this.serverPagination.totalRecords : end;
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      const totalPages = this.totalPages;

      if (totalPages === 0) return pages;

      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    hasSelectedFields() {
      return this.exportFields.some(field => field.selected);
    }
  },

  mounted() {
    this.getPendingInvoices();
    this.menuAccess();
  },

  watch: {
    search() {
      // Reset to first page when searching
      this.currentPage = 1;
      // Debounce search to avoid too many API calls
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getPendingInvoices();
      }, 500);
    },
    selectedFilter() {
      this.currentPage = 1;
      this.getPendingInvoices();
    },
    pageSize() {
      this.currentPage = 1;
      this.getPendingInvoices();
    },
    showExportModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const modalElement = document.getElementById('exportModal');
          if (modalElement) {
            const modal = new bootstrap.Modal(modalElement);
            modal.show();
          }
        });
      }
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Cert Hygiene Pending");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Menu access logged
          })
          .catch((e) => {
            console.error('Menu access error:', e.message);
          });
    },

    formatTimeAgo(dateString) {
      const currentDate = new Date();
      const date = new Date(dateString);
      const timeDifference = currentDate - date;
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

      if (daysDifference === 0) {
        return 'Today';
      } else if (daysDifference === 1) {
        return 'Yesterday';
      } else {
        return `${daysDifference} Days Ago`;
      }
    },

    formattedTime(originalTime) {
      const parsedTime = new Date(originalTime);
      const options = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      };
      return parsedTime.toLocaleTimeString([], options);
    },

    formatDate(dateString) {
      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const date = new Date(dateString);
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    getPendingInvoices() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getPendingInvoices");
      data.append("keyword", this.search);
      data.append("page", this.currentPage);
      data.append("limit", this.pageSize);

      // Add date filters if they exist
      if (this.filterDateRange.startDate) {
        data.append("startDate", this.filterDateRange.startDate);
      }
      if (this.filterDateRange.endDate) {
        data.append("endDate", this.filterDateRange.endDate);
      }

      execute(data, health)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              // Use server response data
              this.pendingInvoicing = res.data.data.pendingInvoicing;

              // Use server-calculated totals
              if (res.data.data.summary) {
                this.totalBusiness = res.data.data.summary.totalBusinesses;
                this.totalAmount = res.data.data.summary.totalAmount;
              }

              // Store pagination info from server
              if (res.data.data.pagination) {
                this.serverPagination = res.data.data.pagination;
              }
            } else {
              this.message = res.data.message;
              this.pendingInvoicing = [];
              this.totalBusiness = 0;
              this.totalAmount = 0;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
            this.pendingInvoicing = [];
          });
    },

    getBusiness(billNo, businessID) {
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", businessID);
      data.append("billNo", billNo);
      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.business = res.data.data.business;
              this.billDetail = res.data.data.bill.billDetails;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    resendMessage() {
      const data = new FormData();
      data.append("function", "resendMessage");
      data.append("customerPhoneNumber", this.business.ownerPhone);
      data.append("incomeTypePrefix", this.billDetail.incomeTypePrefix);
      data.append("billNo", this.billDetail.billNo);
      data.append("name", this.business.businessName);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message);
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    printReceipt(billDetails) {
      localStorage['params'] = JSON.stringify({
        billNo: billDetails.billNo
      });
      const routeData = this.$router.resolve({name: 'receipt'});
      window.open(routeData.href, '_blank');
    },

    // Pagination Methods
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getPendingInvoices();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getPendingInvoices();
      }
    },

    goToPage(page) {
      this.currentPage = page;
      this.getPendingInvoices();
    },

    // Selection Methods
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = this.paginatedInvoices.map(item => item.billNo);
      } else {
        this.selectedItems = [];
      }
    },

    clearSelection() {
      this.selectedItems = [];
      this.selectAll = false;
    },

    // Filter Methods
    applyDateFilter() {
      this.currentPage = 1;
      this.getPendingInvoices();
    },

    clearDateFilter() {
      this.filterDateRange.startDate = '';
      this.filterDateRange.endDate = '';
      this.currentPage = 1;
      this.getPendingInvoices();
    },

    // Bulk Actions
    sendBulkSMS() {
      if (this.selectedItems.length === 0) {
        alert('Please select at least one invoice');
        return;
      }
      // Implement bulk SMS functionality
      alert(`Sending SMS to ${this.selectedItems.length} businesses...`);
    },

    // Export Methods
    exportToCSV() {
      this.isExporting = true;
      this.exportProgress = 0;

      // Start fetching all data in batches
      this.fetchAllDataForExport();
    },

    async fetchAllDataForExport() {
      try {
        const allData = [];
        let currentPage = 1;
        const batchSize = 100; // Fetch 100 records per batch
        let hasMoreData = true;

        // Calculate total pages needed
        const totalRecords = this.serverPagination.totalRecords || 0;
        const totalPages = Math.ceil(totalRecords / batchSize);

        while (hasMoreData && currentPage <= totalPages) {
          // Update progress
          this.exportProgress = Math.floor((currentPage / totalPages) * 90); // 0-90% for fetching

          // Fetch data for current page
          const data = new FormData();
          data.append("function", "getPendingInvoices");
          data.append("keyword", this.search);
          data.append("page", currentPage);
          data.append("limit", batchSize);

          // Add date filters if they exist
          if (this.filterDateRange.startDate) {
            data.append("startDate", this.filterDateRange.startDate);
          }
          if (this.filterDateRange.endDate) {
            data.append("endDate", this.filterDateRange.endDate);
          }

          const response = await execute(data, health);

          if (response.data.success && response.data.data.pendingInvoicing.length > 0) {
            allData.push(...response.data.data.pendingInvoicing);
            currentPage++;

            // Check if we've reached the end
            if (response.data.data.pagination.hasNextPage === false) {
              hasMoreData = false;
            }
          } else {
            hasMoreData = false;
          }

          // Add a small delay to avoid overwhelming the server
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        // Progress: 90% - now generating CSV
        this.exportProgress = 90;

        // If user selected specific items, filter the data
        let dataToExport = allData;
        if (this.selectedItems.length > 0) {
          dataToExport = allData.filter(item => this.selectedItems.includes(item.billNo));
        }

        // Generate and download CSV
        this.generateCSV(dataToExport);

        // Complete
        this.exportProgress = 100;

        setTimeout(() => {
          this.isExporting = false;
          this.exportProgress = 0;
          this.closeExportModal();
          alert(`Export completed successfully! ${dataToExport.length} records exported.`);
        }, 500);

      } catch (error) {
        console.error('Export error:', error);
        this.isExporting = false;
        this.exportProgress = 0;
        alert('Export failed: ' + error.message);
      }
    },

    generateCSV(dataToExport) {
      const selectedFields = this.exportFields.filter(f => f.selected);

      // Create CSV content
      const headers = selectedFields.map(f => f.label).join(',');
      const rows = dataToExport.map(item => {
        return selectedFields.map(field => {
          let value = item[field.key] || '';
          if (field.key === 'dateCreated') {
            value = this.formatDate(value);
          }
          // Escape quotes and wrap in quotes
          value = String(value).replace(/"/g, '""');
          return `"${value}"`;
        }).join(',');
      });

      const csv = [headers, ...rows].join('\n');

      // Download CSV
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      // Create filename with date range if applicable
      let filename = 'pending_invoices';
      if (this.filterDateRange.startDate || this.filterDateRange.endDate) {
        filename += `_${this.filterDateRange.startDate || 'start'}_to_${this.filterDateRange.endDate || 'end'}`;
      }
      filename += `_${new Date().toISOString().split('T')[0]}.csv`;

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },

    closeExportModal() {
      this.showExportModal = false;
      const modalElement = document.getElementById('exportModal');
      if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    },

    selectAllFields() {
      this.exportFields.forEach(field => {
        field.selected = true;
      });
    },

    deselectAllFields() {
      this.exportFields.forEach(field => {
        field.selected = false;
      });
    },

    // Payment Methods
    closeAllModals() {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });
    },

    showPaymentMethod() {
      this.closeAllModals();
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;

      if (this.billDetail && this.billDetail.billNo && this.billDetail.billBalance) {
        this.paymentData.amount = parseFloat(this.billDetail.billBalance);
        this.paymentData.accNo = this.billDetail.billNo;
      }

      this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
      this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
      this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");

      const paymentModal = new bootstrap.Modal(document.getElementById('payment-modal'));
      paymentModal.show();
    },

    updatePhoneNumber(phoneNumber) {
      this.phoneNumber = phoneNumber;
      this.paymentData.phoneNumber = phoneNumber;
    },

    showTransactionSummary(localPaymentData) {
      Object.assign(this.paymentData, localPaymentData);
      this.phoneNumber = localPaymentData.phoneNumber;

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
    },

    makePayment(localPaymentData) {
      Object.assign(this.paymentData, localPaymentData);

      this.message = "Payment Request sent";

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      let stream = biller;
      if (this.paymentData.accNo.startsWith("SBP")) stream = trade;
      if (this.paymentData.accNo.startsWith("PKN")) stream = parking;
      if (this.paymentData.accNo.startsWith("RNT")) stream = rent;
      if (this.paymentData.accNo.startsWith("BLL")) stream = biller;
      if (this.paymentData.accNo.startsWith("HYG")) stream = health;

      execute(data, stream)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.timer = setInterval(() => {
                this.checkPayment();
              }, 3000);
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    checkPayment() {
      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("billNo", this.paymentData.accNo);

      let stream = biller;
      if (this.paymentData.accNo.startsWith("SBP")) stream = trade;
      if (this.paymentData.accNo.startsWith("PKN")) stream = parking;
      if (this.paymentData.accNo.startsWith("RNT")) stream = rent;
      if (this.paymentData.accNo.startsWith("BLL")) stream = biller;
      if (this.paymentData.accNo.startsWith("HYG")) stream = health;

      execute(data, stream)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data.status === 'PAID') {
                clearInterval(this.timer);
                this.receiptDetails = res.data.data.receipt;
                this.transactionSummary = false;
                this.transactionCompleted = true;
                this.getPendingInvoices();
              }
            }
          })
          .catch((e) => {
            console.error('Error checking payment:', e.message);
          });
    },

    printReceiptFromPayment() {
      this.printReceipt(this.receiptDetails);
    }
  }
}
</script>

<style scoped>
/* Enhanced UI Styles */
.mini-stats-wid .card-body {
  padding: 20px;
}

.mini-stat-icon {
  width: 48px;
  height: 48px;
}

.hover-row {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-row:hover {
  background-color: #f8f9fa !important;
  transform: translateX(2px);
}

.table-active {
  background-color: #e7f3ff !important;
}

.btn-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
  border: none;
}

.btn-soft-primary:hover {
  color: #fff;
  background-color: #556ee6;
}

.btn-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
  border: none;
}

.btn-soft-success:hover {
  color: #fff;
  background-color: #34c38f;
}

.btn-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
  border: none;
}

.btn-soft-info:hover {
  color: #fff;
  background-color: #50a5f1;
}

.badge {
  padding: 0.5em 0.75em;
  font-weight: 500;
}

.bg-info-subtle {
  background-color: rgba(80, 165, 241, 0.18);
  color: #50a5f1;
}

.table > :not(caption) > * > * {
  padding: 0.75rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-weight: 500;
  font-size: 0.875rem;
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.18) !important;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: none;
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #eff2f7;
}

.card-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #eff2f7;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  color: #556ee6;
  border: 1px solid #dee2e6;
}

.page-item.active .page-link {
  background-color: #556ee6;
  border-color: #556ee6;
}

.dataTables_info {
  color: #74788d;
  font-weight: 500;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.form-check-input:checked {
  background-color: #556ee6;
  border-color: #556ee6;
}

.gap-1 {
  gap: 0.25rem;
}

.font-size-64 {
  font-size: 64px;
}

.font-size-24 {
  font-size: 24px;
}

/* Search input styling */
.app-search .form-control {
  border: 1px solid #ced4da;
  padding-left: 40px;
}

.app-search .bx-search-alt {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #74788d;
}

/* Export Modal Styles */
.export-options .form-check {
  cursor: pointer;
  transition: all 0.3s ease;
}

.export-options .form-check:hover {
  border-color: #556ee6 !important;
}

.export-options .form-check.bg-light {
  background-color: #e7f3ff !important;
  border-color: #556ee6 !important;
}

.export-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
}

.progress {
  border-radius: 8px;
}

.progress-bar {
  font-size: 14px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }

  .card-body {
    padding: 1rem;
  }

  .d-flex.align-items-center {
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>